module.exports = __webpack_public_path__ + "media/profile/xp-trophy-54a909b2.png";